import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import Banner from "../components/Banner";
import Disclosure from "../components/Policy Pages/Annexture";


const AnnexturePage = () => {
  return (
    <>
      <Banner />
      <section className="hidden lg:block">
        <Navbar />
        <Warning />
      </section>
      <section className="block lg:hidden">
        <Sidebar />
      </section>
      <Disclosure />
      <Footer />
    </>
  );
};

export default AnnexturePage;
